module.exports = function() {
  return new Worker(__webpack_public_path__ + "e7e581c912a523c0d42a.worker.js");
};